import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractReportExporter from "./AbstractReportExporter.js";
import CsvExportingVisitor from "../visitors/exporters/CsvExportingVisitor.js";

/**
 * TODO: write documentation
 */
export default class CsvExporter extends AbstractReportExporter {
	simpleLabel() {
		return _("CSV");
	}

	_exportingVisitorClass() {
		return CsvExportingVisitor;
	}

	_mimetype() {
		return "text/cvs;charset=utf-8;";
	}

	_filenameExtension() {
		return "csv";
	}
}
